// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lxNGxP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  min-height: 300px;
  flex: 1;
}

.wHIaML {
  font-size: 64px;
  margin-bottom: 24px;
  line-height: 1;
}

.hz5Mch {
  width: 72px;
  height: 72px;
  background-color: #d640001a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.LgRAW5 {
  font-size: 18px;
  font-weight: 600;
  color: var(--bs-gray-900);
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.B5zZl8 {
  font-size: 14px;
  color: var(--bs-gray-600);
  margin: 0;
  line-height: 1.5;
  max-width: 320px;
}

.yUVkyq {
  margin-top: 24px;
  padding: 12px 24px;
  background-color: var(--text-primary-medium);
  color: var(--bs-white);
  border: none;
  border-radius: 8px;
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.yUVkyq:active {
  transform: scale(0.98);
}

@media (max-width: 768px) {
  .lxNGxP {
    padding: 32px 16px;
    min-height: 250px;
  }

  .wHIaML {
    font-size: 48px;
    margin-bottom: 16px;
  }

  .LgRAW5 {
    font-size: 16px;
  }

  .B5zZl8 {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmptyState/EmptyState.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  min-height: 300px;\n  flex: 1;\n}\n\n.icon {\n  font-size: 64px;\n  margin-bottom: 24px;\n  line-height: 1;\n}\n\n.iconWithCircle {\n  width: 72px;\n  height: 72px;\n  background-color: #d640001a;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--bs-gray-900);\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.message {\n  font-size: 14px;\n  color: var(--bs-gray-600);\n  margin: 0;\n  line-height: 1.5;\n  max-width: 320px;\n}\n\n.feedbackButton {\n  margin-top: 24px;\n  padding: 12px 24px;\n  background-color: var(--text-primary-medium);\n  color: var(--bs-white);\n  border: none;\n  border-radius: 8px;\n  font-size: var(--font-size-md);\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.feedbackButton:active {\n  transform: scale(0.98);\n}\n\n@media (max-width: 768px) {\n  .emptyState {\n    padding: 32px 16px;\n    min-height: 250px;\n  }\n\n  .icon {\n    font-size: 48px;\n    margin-bottom: 16px;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .message {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `lxNGxP`,
	"icon": `wHIaML`,
	"iconWithCircle": `hz5Mch`,
	"title": `LgRAW5`,
	"message": `B5zZl8`,
	"feedbackButton": `yUVkyq`
};
module.exports = ___CSS_LOADER_EXPORT___;
